export const FormLabelCheckbox = {
  transclude: true,

  bindings: {
    name: '<',
    active: '<',
    disabled: '<',
    model: '=?',
    value: '<',
    onClick: '&',
  },

  template: `
    <label
      class="radio-answer p-3 d-flex justify-content-center align-items-center text-center rounded"
      ng-class="{
        'theme-mid theme-color bg-cz-theme-secondary': $ctrl.active,
        'bg-whitesmoke': !$ctrl.active,
        'text-dark': !$ctrl.disabled && !$ctrl.active,
        'text-light': $ctrl.disabled,
      }">
      <input
        class="d-none"
        type="checkbox"
        name="{{ $ctrl.name }}"
        value="{{ $ctrl.value }}"
        ng-disabled="$ctrl.disabled"
        ng-model="$ctrl.model"
        ng-click="$ctrl.onClick({ value: $ctrl.value })">
      <ng-transclude></ng-transclude>
    </label>`,
};



// WEBPACK FOOTER //
// ./src/components/FormElements/FormLabelCheckbox.js